import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { scrollToOffer } from '../utils/scrollToOffer';
export function FinalCtaSection() {
  return <section className="px-6 py-40 md:py-56 bg-black text-white text-center" data-id="element-23">
      <div className="w-full max-w-5xl mx-auto" data-id="element-24">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tight mb-16 leading-[1.1]" data-id="element-25">
          No te falta talento. <br data-id="element-26" />
          <span className="text-gray-500" data-id="element-27">
            Te faltan{' '}
            <strong className="font-black text-white" data-id="element-28">clientes</strong>.
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center" data-id="element-29">
          <button onClick={scrollToOffer} className="w-full max-w-lg bg-white text-black font-black text-xl md:text-2xl h-20 rounded-2xl flex items-center justify-center gap-3 hover:bg-gray-200 transition-colors active:scale-[0.98] shadow-2xl" data-id="element-30">
            Empezar a conseguir clientes <ArrowRight className="w-7 h-7" data-id="element-31" />
          </button>
        </motion.div>
      </div>
    </section>;
}